import { Text, Flex } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import { FormikProps } from 'formik';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

export const PrincipalBalancePointInTimeConfig: React.FC<{
  formProps: FormikProps<CreditAgreement.Config.PortfolioCovenant.PrincipalBalancePointInTimeQuery>;
}> = ({ formProps }) => {
  return (
    <Flex flexDir="column">
      <Flex mb="3">
        <Text>Date Formula:</Text>
        <Editor
          value={formProps.values.parameterConfig.dateFormula.formula}
          onChange={(val) =>
            formProps.setFieldValue('parameterConfig.dateFormula.formula', val)
          }
          width="100%"
          theme="vs-dark"
          height="15vh"
        />
      </Flex>
    </Flex>
  );
};
